export const RoundOneIntroSeconds = 90;
export const SceneCreationSeconds = 80;
export const LoadFirstWatchSeconds = 8;
export const LoadWatchSeconds = 7;
export const WatchSceneSeconds = 12;
export const TemplateSelectSeconds = 30;
export const AddOptionsSeconds = 60;
export const VotingSeconds = 30;
export const FinalWatchSceneSeconds = 8;
